<template>
  <v-dialog
    v-model="openDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @click:outside="close"
    class="modal-visualizacao-img"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="downloadFile(urlImg)"> Salvar </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-row class="mt-2" justify="center" style="width: 100%">
        <img :src="urlImg" class="img-view" />
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import RegistroImagemService from "../../../common/services/http/registroImagem.service";
export default {
  name: "ModalDialogVisualizacaoImg",
  data() {
    return {
      openDialog: false,
      urlImg: "",
    };
  },
  props: {
    imgFile: {
      type: [Object, Blob],
    },
    visivel: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    visivel: function (newDialogVisualizacao) {
      this.openDialog = newDialogVisualizacao;
    },
    imgFile(newValue) {
      if (Object.keys(newValue).length > 0 || newValue instanceof Blob)
        this.gerarUrl();
    },
  },
  methods: {
    async gerarUrl() {
      if (
        Object.keys(this.imgFile).length == 0 &&
        !(this.imgFile instanceof Blob)
      )
        return;
      const blob =
        this.imgFile instanceof Blob
          ? this.imgFile
          : await RegistroImagemService.visualizar(this.imgFile.id);

      const url = URL.createObjectURL(blob);
      this.urlImg = url;
    },
    close() {
      this.$emit("close");
    },
    downloadFile(url) {
      window.open(url);
    },
  },
};
</script>
<style scoped>
.modal-visualizacao-img {
  width: 100vw;
  height: 100vh;
  margin-left: 12px;
  margin-top: 12px;
  overflow: hidden;
}
img.img-view {
  width: auto;
  height: auto;
  max-width: calc(100vw - 64px);
  max-height: calc(100vh - 72px);
}
</style>
